import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex } from 'antd';

import { AccountStats, PersonalInfo } from 'entities/User';
import { useAppConfigRetrieveQuery } from 'shared/api';
import { useBackButton } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';
import { Content, Page, PageTitle } from 'shared/ui';

import styles from './Profile.module.scss';

interface IProfileProps extends HTMLAttributes<HTMLDivElement> {}

export const Profile: FC<IProfileProps> = ({ ...props }) => {
	const { t } = useTranslation();
	useBackButton(`${EMainRoutes.DASHBOARD}`);
	const { data: appConfig } = useAppConfigRetrieveQuery();

	return (
		<Page {...props}>
			<PageTitle
				image={
					<img
						src={appConfig?.user?.tg_photo_url}
						height={80}
						width={80}
						alt={appConfig?.user?.tg_first_name}
						className={styles.image}
					/>
				}
				subtitle={t(
					'В этом разделе вы можете настроить свой профиль. Часть информации была взята из вашего профиля в Телеграме',
				)}>
				{appConfig?.user?.tg_first_name || appConfig?.user?.tg_last_name
					? `${appConfig?.user?.tg_first_name} ${appConfig?.user?.tg_last_name}`
					: appConfig?.user?.tg_username}
			</PageTitle>
			<Content>
				<Flex vertical gap={8}>
					<PersonalInfo />
					<AccountStats />
				</Flex>
			</Content>
		</Page>
	);
};

export default Profile;
